import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  advisorViewLayoutHeader: {
    margin: '16px 24px 24px'
  }
}))

const Header = ({ children, className, style }) => {
  const classes = useStyles()
  return (
    <div className={clsx(classes.advisorViewLayoutHeader, className)} style={style}>
      {children}
    </div>
  )
}

Header.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Header
